import { API_URL } from "../../../config";

// JSON by default; pass a FormData body for file uploads (the browser sets
// the multipart boundary itself, so Content-Type must not be set then).
export const helpRequest = async (path, { method = "GET", body } = {}) => {
  const headers = { "x-access-token": localStorage.getItem("accessToken") };
  let payload;
  if (body instanceof FormData) {
    payload = body;
  } else if (body) {
    headers["Content-Type"] = "application/json";
    payload = JSON.stringify(body);
  }

  const res = await fetch(`${API_URL}${path}`, { method, headers, body: payload });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.status === false) {
    throw new Error(data.message || "Something went wrong");
  }
  return data;
};
